import { ProjectStateReducerCreator } from '../types';

const clearSaveSessionAfterProjectSaveReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state) => {
    state.sessionsToUpdateAfterProjectSave = null;
  });
};

export default clearSaveSessionAfterProjectSaveReducer;
